import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import StorefrontHeroActions from './components/StorefrontHeroActions';
import { useSiteSettings } from './SiteSettingsContext';
import PageSeoHelmet from './PageSeoHelmet';
import { SITE_SETTINGS_DEFAULTS } from './siteSettingsDefaults';

function About() {
  const { settings: site } = useSiteSettings();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const aboutCopy = site.page_copy?.about || {};
  const values = aboutCopy.values || [];

  return (
    <div className="about-page">
      <PageSeoHelmet page="about" />

      <div className="container store-page__container">
        <section className="about-hero shop-hero">
          <div className="about-hero-panel text-center">
            <p className="shop-hero-eyebrow">Saloni Designs</p>
            <h1 className="shop-page-title">{site.about_hero_title || SITE_SETTINGS_DEFAULTS.about_hero_title}</h1>
            <p className="shop-page-subtitle handwritten">
              {site.about_hero_subtitle || SITE_SETTINGS_DEFAULTS.about_hero_subtitle}
            </p>
            <StorefrontHeroActions placement="about" />
          </div>
        </section>
      </div>

      <section className="about-brand about-page-brand">
        <div className="container store-page__container">
          <div className="about-card">
            <div className="row align-items-center">
              <div className="col-md-4">
                <div className="about-image-wrapper">
                  <img
                    src="/saloni-logo.png"
                    alt="Saloni Designs"
                    className="about-image about-image--logo"
                    width={200}
                    height={200}
                  />
                </div>
              </div>
              <div className="col-md-8">
                <h2 className="about-title handwritten">{aboutCopy.story_heading}</h2>
                <p className="about-text">{site.about_para1 || SITE_SETTINGS_DEFAULTS.about_para1}</p>
                <p className="about-text">{site.about_para2 || SITE_SETTINGS_DEFAULTS.about_para2}</p>
                <p className="about-text mb-0">{site.about_para3 || SITE_SETTINGS_DEFAULTS.about_para3}</p>
                <p className="about-tagline handwritten mt-4 mb-0">
                  &quot;{site.about_tagline || SITE_SETTINGS_DEFAULTS.about_tagline}&quot;
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container store-page__container">
        <section className="about-values">
          <div className="section-header text-center mb-4">
            <h2 className="section-title mb-2">{aboutCopy.values_title}</h2>
            <p className="section-subtitle mb-0">{aboutCopy.values_subtitle}</p>
          </div>
          <div className="row g-4">
            {values.map((v, i) => (
              <div className="col-md-4 d-flex" key={`value-${i}`}>
                <div className="value-card w-100">
                  <div className="value-icon" aria-hidden="true">{v.icon}</div>
                  <h3 className="value-title">{v.title}</h3>
                  <p className="value-desc mb-0">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="about-page-cta text-center">
          <p className="about-page-cta-lead mb-3">{aboutCopy.cta_lead}</p>
          <Link to="/contact" className="btn btn-primary btn-lg me-sm-2 d-inline-block mb-2 mb-sm-0">
            {aboutCopy.cta_primary_label}
          </Link>
          <Link to="/shop" className="btn btn-outline-secondary btn-lg d-inline-block ms-sm-2">
            {aboutCopy.cta_secondary_label}
          </Link>
        </section>
      </div>
    </div>
  );
}

export default About;
